// extracted by mini-css-extract-plugin
module.exports = {"root":"information_root__3Q3cb","value":"information_value__1oYP9"};